import { Mutation, Action } from 'vuex-module-decorators';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { Resolve } from 'vue-di';
import { SurveySessionValueModel } from '@trialcard/apigateway.models';
import SurveyModule from './survey';
import { Settings } from '~/services/settings';

export interface IEligibilityQuestions {
    surveySessionId: string;
    questionId: number;
    answerId: number;
}
export interface IEligibilityData {
    question1: SurveySessionValueModel;
    question2: SurveySessionValueModel;
    question3: SurveySessionValueModel;
    question4: SurveySessionValueModel;
    question5: SurveySessionValueModel;
    question6: SurveySessionValueModel;
}
@InjectModule({ stateFactory: true }, module)
export default class EligibilityModule extends InjectVuexModule {
    @Resolve
    settings!: Settings;
    @Resolve
    survey!: SurveyModule;

    eligibilityData = {} as IEligibilityData;
    eligibilityRequestData = [] as SurveySessionValueModel[];


    @Action({ rawError: true })
    public setEligibility(newEligibilityData: IEligibilityData) {
        this.updateEligibilityData(newEligibilityData);

        const newEligibilityRequestData = Object.entries(newEligibilityData).map(question => question[1]);
        this.updateEligibilityRequestData(newEligibilityRequestData);
    }

    @Action({ rawError: true })
    public async fetchSurveySession() {
        await this.survey.fetchSurveySession(this.eligibilityRequestData);
    }

    @Action({ rawError: true })
    public clear() {
        this.clearEligibilityData();
        this.clearEligibilityRequestData();
    }

    @Mutation
    updateEligibilityData(newEligibilityData: IEligibilityData) {
        this.eligibilityData = { ...this.eligibilityData, ...newEligibilityData };
    }

    @Mutation
    updateEligibilityRequestData(newEligibilityRequestData: SurveySessionValueModel[]) {
        this.eligibilityRequestData = [...this.eligibilityRequestData, ...newEligibilityRequestData];
    }

    @Mutation
    clearEligibilityData() {
        this.eligibilityData = {} as IEligibilityData;
    }

    @Mutation
    clearEligibilityRequestData() {
        this.eligibilityRequestData = [];
    }
}
